
module.exports = (v) => {
  return v.replace(/[^0-9]/gim, '');
};
